const REGISTRATION_PAGE_ID = "registration";

function findRegistrationPage(pages) {
	if (!Array.isArray(pages)) return null;
	return pages.find((p) => p && String(p.pageId || p._id || "") === REGISTRATION_PAGE_ID);
}

/**
 * Config efectiva de registro en la web: `game.registerConfig` + overrides en la página de registro del ER.
 */
export function getEffectiveRegisterConfig(game) {
	const base = {
		mode: normalizeRegisterMode(game?.registerConfig?.mode),
		maxPeoplePerTable: Number(game?.registerConfig?.maxPeoplePerTable ?? 0),
		photoEnabled: typeof game?.registerConfig?.photoEnabled === "boolean" ? game.registerConfig.photoEnabled : false,
	};
	if (!game) return base;
	const er = game.escapeRoom;
	const pages = er && typeof er === "object" ? er.pages : null;
	const regPage = findRegistrationPage(pages);
	const rc = regPage?.registrationDesign?.registerConfig;
	if (!rc || typeof rc !== "object") return base;
	const out = { ...base };
	if (rc.mode === "simple" || rc.mode === "table") {
		out.mode = normalizeRegisterMode(rc.mode);
	}
	if (typeof rc.photoEnabled === "boolean") {
		out.photoEnabled = rc.photoEnabled;
	}
	const maxP = Number(rc.maxPeoplePerTable);
	if (Number.isFinite(maxP)) {
		out.maxPeoplePerTable = Math.max(0, Math.round(maxP));
	}
	return out;
}

function normalizeRegisterMode(mode) {
	const m = String(mode || "simple").toLowerCase();
	if (m === "table") return "table";
	return "simple";
}

/** Logo de la página de registro configurado en el escape room. */
export function getEffectiveRegistrationLogoUrl(game) {
	const er = game?.escapeRoom;
	const pages = er && typeof er === "object" ? er.pages : null;
	const regPage = findRegistrationPage(pages);
	const rd = regPage?.registrationDesign;
	if (!rd || typeof rd !== "object") return "";
	const raw = rd.logoUrl || rd.logoOncommitUrl || rd.logoJandJUrl || "";
	return typeof raw === "string" ? raw.trim() : "";
}

/** Número de mesas en el desplegable (override del ER o `game.numTables`). */
export function getEffectiveNumTables(game) {
	const nGame = parseInt(String(game?.numTables || "0"), 10);
	const safeGame = Number.isFinite(nGame) && nGame > 0 ? nGame : 1;
	const er = game?.escapeRoom;
	const pages = er && typeof er === "object" ? er.pages : null;
	const regPage = findRegistrationPage(pages);
	const raw = regPage?.registrationDesign?.registerConfig?.numTables;
	const nEr = parseInt(String(raw ?? ""), 10);
	if (Number.isFinite(nEr) && nEr > 0) return nEr;
	return safeGame;
}
